import { render, staticRenderFns } from "./AppRegion.vue?vue&type=template&id=27c9315e&scoped=true&"
import script from "./AppRegion.vue?vue&type=script&lang=js&"
export * from "./AppRegion.vue?vue&type=script&lang=js&"
import style0 from "./AppRegion.vue?vue&type=style&index=0&id=27c9315e&prod&lang=scss&scoped=true&"
import style1 from "./AppRegion.vue?vue&type=style&index=1&id=27c9315e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c9315e",
  null
  
)

export default component.exports